export class NameSpacer {
    static getDataShapeDescriptor(shapeStr) {
        const splitArray = shapeStr.split('.');
        if (splitArray.length !== 3) {
            throw new Error(`shapeStr [${shapeStr}] not valid`);
        }
        else {
            return {
                course: splitArray[0],
                dataShape: splitArray[2],
            };
        }
    }
    static getDataShapeString(shapeDescription) {
        return `${shapeDescription.course}.datashape.${shapeDescription.dataShape}`;
    }
    static getViewDescriptor(viewStr) {
        const splitArray = viewStr.split('.');
        if (splitArray.length !== 4) {
            throw new Error('viewStr not valid');
        }
        else {
            return {
                course: splitArray[0],
                questionType: splitArray[2],
                view: splitArray[3],
            };
        }
    }
    static getViewString(viewDescription) {
        return (`${viewDescription.course}.question.` +
            `${viewDescription.questionType}.${viewDescription.view}`);
    }
    static getQuestionDescriptor(questionStr) {
        const splitArray = questionStr.split('.');
        if (splitArray.length !== 3) {
            throw new Error('questionStr not valid');
        }
        else {
            return {
                course: splitArray[0],
                questionType: splitArray[2],
            };
        }
    }
    static getQuestionString(questionDescription) {
        return `${questionDescription.course}.question.${questionDescription.questionType}`;
    }
}
//# sourceMappingURL=namespacer.js.map